import React, { useEffect, useState } from 'react';
import './TandC.css';

const TermsAndConditions = () => {
    const [lastUpdated, setLastUpdated] = useState('');

  useEffect(() => {
    // Get today's date
    const today = new Date();
    const daysSinceStart = Math.floor(today.getTime() / (1000 * 60 * 60 * 24));

    // Find the most recent date that aligns with the 3-day interval
    const mostRecentInterval = daysSinceStart - (daysSinceStart % 3);
    const lastUpdatedDate = new Date(mostRecentInterval * 1000 * 60 * 60 * 24);

    // Format the date as needed (e.g., "November 7, 2024")
    const formattedDate = lastUpdatedDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

    setLastUpdated(formattedDate);
  }, []);
  return (
    <div className="terms-container">
      <div className="terms-header">
        <h2>Terms and Conditions</h2>
        <p>Last Updated: {lastUpdated}</p>
      </div>

      <div className="terms-content">
        <div className="term-section">
          <h3 className="term-title">1. Definitions</h3>
          <p>
            <strong>1.1.</strong> "Adcore Consulting" refers to our company, located at 12 Alade Street, Shomolu, Lagos, Nigeria.
          </p>
          <p>
            <strong>1.2.</strong> "Customer" or "User" refers to anyone using our website or services.
          </p>
        </div>

        <div className="term-section">
          <h3 className="term-title">2. Services</h3>
          <p>
            Adcore Consulting provides printing and related services as described on our website. We reserve the right to modify or discontinue our services without notice.
          </p>
        </div>

        <div className="term-section">
          <h3 className="term-title">3. Ordering and Payment</h3>
          <p>
            By placing an order, you agree to provide accurate and up-to-date information. You are responsible for verifying that the details of your order are correct before confirming your purchase.
          </p>
        </div>

        {/* Additional terms sections as needed */}

        <div className="term-section">
          <h3 className="term-title">Contact Information</h3>
          <p>If you have any questions, please contact us at:</p>
          <p><strong>Email:</strong> adcoreconsulting@gmail.com</p>
          <p><strong>Phone:</strong> +234 802 387 9629</p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
